import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
function ConfigurationItemDiaryReferenceDocumentDialog(tabPage, parent) {
    var self = this;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.Dialog.IsLoading(true);
                self.DialogViewModel.Upload().then(function () {
                    self.Dialog.IsLoading(false);
                    self.DialogResult("ok");
                    self.Dialog.Close();
                });
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogViewModel.DiaryReferenceDocumentButtons = ko.observableArray();
    self.DialogResult = ko.observable();
    self.DialogViewModel.Upload = function () { };
    self.Show = function (configurationItemId, configurationItemDiaryId, configurationItemDiaryReferenceDocumentId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemTab/ShowConfigurationItemDiaryReferenceDocumentDialog", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItemDiaryId: configurationItemDiaryId,
            configurationItemDiaryReferenceDocumentId: configurationItemDiaryReferenceDocumentId
        }), function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel);
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.Class() == null || self.DialogViewModel.Class() == "") {
            isComplete = false;
        }
        if (self.DialogViewModel.DocumentName() == null || self.DialogViewModel.DocumentName() == "") {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
export default ConfigurationItemDiaryReferenceDocumentDialog;